import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import Tabs from '../AdminTabs';
import AdminTable from '../AdminTable';
import AdminModalForm from '../AdminModalForm';
import { MODELS } from '../../../constants/admin/settings';
import {
    fetchList,
    deleteContracts,
    archiveContracts,
    fetchArchivedList,
    sendContractReminder
} from '../../../actions/admin/models/contracts';
import { forceFetchEvents } from '../../../actions/events/select';
import * as templateActions from '../../../actions/admin/models/templates';
import { msToTime } from '../../../lib/date.utils';
import { TABLE_INDICES } from '../../../constants/admin/tables';
import SignState from '../../../components/application/contracts/SignState';
import { get, compact, capitalize } from 'lodash';
import {
    canAccessClearanceInAdminSelector,
    canAccessPerformanceInAdminSelector,
    currentUserSelector
} from '../../../selectors/authentication';
import { openModalFormWithData } from '../../../actions/admin/modal.forms';
import CommentsModalForm from '../../../components/admin/forms/contracts/CommentsModalForm';
import ContractsAdvancedSearch from './ContractsAdvancedSearch';
import {
    selectedRowPublicUrlSelector,
    totalResultsSelector,
    canSendReminderSelector,
    selectedRowContractIdsSelector
} from '../../../selectors/admin/tables';
import { CONTRACT_TYPES } from '../../../constants/settings';
import { Snackbar } from '@material-ui/core';
import { currentTabSelector } from '../../../selectors/admin/tabs';
import ArchiveSearchForm from './ArchiveSearchForm';
import { downloadContract } from '../../../actions/admin/models/contracts';

class Index extends Component {
    state = { archiving: false, performanceAmount: 0, clearanceAmount: 0, showCopyToast: false };
    _transformRows = {
        dueDate: dd => msToTime(dd),
        lastReminderDate: dd => msToTime(dd),
        updatedAt: ua => msToTime(ua, true),
        state: (_, d) => <SignState state={get(d, 'version.state', '')} />,
        artistName: (_, d) => get(d, 'artist.name', ''),
        eventName: (_, d) => get(d, 'event.name', ''),
        hasComments: (hc, d) => {
            return hc ? 'Yes' : 'No';
        }
    };

    componentDidMount() {
        this.props.forceFetchEvents();
    }

    _openReminderModal = () => {
        this.props.openModalFormWithData(MODELS.CONTRACT_REMINDER, { comments: '' });
    };

    _copyPublicLinkToClipboard = () => {
        //     const publicUrl = `${window.location.origin}/review/${this.props.allowCopyPublicUrl}`;
        //     copyTextToClipboard(publicUrl).then(() => { return this._handleOpenToast() });
        return this._handleOpenToast();
    };

    _handleCloseToast = () => {
        this.setState({ showCopyToast: false });
    };

    _handleOpenToast = () => {
        this.setState({ showCopyToast: true });
    };

    _download = () => {
        this.props.downloadContract(this.props.downloadIds.contractId, this.props.downloadIds.versionId, false);
    };

    render() {
        const _selectionFunctions = [
            ...(this.props.canSendReminder ? [this._openReminderModal] : []),
            this.props.archiveContracts,
            ...(this.props.allowCopyPublicUrl ? [this._copyPublicLinkToClipboard] : []),
            ...(this.props.downloadIds ? [this._download] : [])
        ];

        return (
            <React.Fragment>
                <Snackbar
                    className="ckp-snackbar ckp-snackbar--top"
                    open={this.state.showCopyToast}
                    autoHideDuration={3000}
                    onClose={this._handleCloseToast}
                    message="Public link copied to clipboard."
                    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                />
                <Tabs
                    disable={false}
                    labels={compact([
                        this.props.canAccessClearanceContracts ? `Clearance Contracts` : null,
                        this.props.canAccessPerformanceContracts ? `Performance Contracts` : null,
                        ...(this.props.canAccessPerformanceContracts || this.props.canAccessClearanceContracts
                            ? ['Templates']
                            : [null]),
                        ...(this.props.canAccessPerformanceContracts || this.props.canAccessClearanceContracts
                            ? ['Archive']
                            : [null])
                    ])}
                    content={compact([
                        this.props.canAccessClearanceContracts ? (
                            <React.Fragment>
                                <AdminModalForm
                                    title="Send contract reminder"
                                    fields={CommentsModalForm}
                                    model={MODELS.CONTRACT_REMINDER}
                                    createAction={this.props.sendContractReminder}
                                    createLabel="Send"
                                />
                                <AdminTable
                                    AdvancedSearchForm={ContractsAdvancedSearch}
                                    key={1}
                                    enableSearch={true}
                                    model={MODELS.CONTRACT}
                                    fetchDataFunction={this.props.fetchList}
                                    deleteAction={this.props.deleteContracts}
                                    copyPublicLinkAction={this._copyPublicLinkToClipboard}
                                    selectionActions={[
                                        ...(this.props.canSendReminder ? ['SEND REMINDER'] : []),
                                        'ARCHIVE',
                                        ...(this.props.allowCopyPublicUrl ? ['COPY PUBLIC LINK'] : []),
                                        ...(this.props.downloadIds ? ['DOWNLOAD CONTRACT'] : [])
                                    ]}
                                    selectionFunctions={_selectionFunctions}
                                    pagination={true}
                                    transformFunctions={this._transformRows}
                                    type={CONTRACT_TYPES.CLEARANCE}
                                />
                            </React.Fragment>
                        ) : null,
                        this.props.canAccessPerformanceContracts ? (
                            <React.Fragment>
                                <AdminModalForm
                                    title="Send contract reminder"
                                    fields={CommentsModalForm}
                                    model={MODELS.CONTRACT_REMINDER}
                                    createAction={this.props.sendContractReminder}
                                    createLabel="Send"
                                />
                                <AdminTable
                                    AdvancedSearchForm={ContractsAdvancedSearch}
                                    key={0}
                                    enableSearch={true}
                                    model={MODELS.CONTRACT}
                                    fetchDataFunction={this.props.fetchList}
                                    deleteAction={this.props.deleteContracts}
                                    selectionActions={[
                                        ...(this.props.canSendReminder ? ['SEND REMINDER'] : []),
                                        'ARCHIVE',
                                        ...(this.props.allowCopyPublicUrl ? ['COPY PUBLIC LINK'] : []),
                                        ...(this.props.downloadIds ? ['DOWNLOAD CONTRACT'] : [])
                                    ]}
                                    copyPublicLinkAction={this._copyPublicLinkToClipboard}
                                    selectionFunctions={_selectionFunctions}
                                    pagination={true}
                                    transformFunctions={this._transformRows}
                                    type={CONTRACT_TYPES.PERFORMANCE}
                                />
                            </React.Fragment>
                        ) : null,
                        this.props.canAccessPerformanceContracts || this.props.canAccessClearanceContracts ? (
                            <AdminTable
                                key={2}
                                enableSearch={true}
                                tableIndex={TABLE_INDICES[MODELS.TEMPLATE]}
                                model={MODELS.TEMPLATE}
                                fetchDataFunction={this.props.fetchTemplates}
                                deleteAction={this.props.deleteTemplates}
                                openItem={this.props.openTemplate}
                                pagination={true}
                                buttonAction={this.props.goToNewTemplate}
                                transformFunctions={{
                                    type: t => capitalize(t)
                                }}
                            />
                        ) : null,
                        this.props.canAccessPerformanceContracts || this.props.canAccessClearanceContracts ? (
                            <AdminTable
                                key={3}
                                AdvancedSearchForm={ArchiveSearchForm}
                                disableButtonAction={true}
                                enableSearch={true}
                                model={MODELS.CONTRACT}
                                fetchDataFunction={this.props.fetchArchivedList}
                                deleteAction={this.props.deleteContracts}
                                pagination={true}
                                transformFunctions={this._transformRows}
                            />
                        ) : null
                    ])}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => ({
    user: currentUserSelector(state),
    currentTab: currentTabSelector(state),
    canAccessPerformanceContracts: canAccessPerformanceInAdminSelector(state),
    canAccessClearanceContracts: canAccessClearanceInAdminSelector(state),
    totalClearanceResults: totalResultsSelector(state, { tableIndex: 0 }),
    totalPerformanceResults: totalResultsSelector(state, { tableIndex: 1 }),
    allowCopyPublicUrl: selectedRowPublicUrlSelector(state, props),
    downloadIds: selectedRowContractIdsSelector(state, props),
    canSendReminder: canSendReminderSelector(state, props)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchList,
            forceFetchEvents,
            archiveContracts,
            sendContractReminder,
            deleteContracts,
            openModalFormWithData,
            fetchArchivedList,
            downloadContract,
            ...templateActions
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withBreadcrumb(Index, () => [BREADCRUMB.CONTRACTS]));
